import { extendTailwindMerge } from 'tailwind-merge'

const customTwMerge = extendTailwindMerge({
  prefix: 'tw-',
})

export const mergeClasses = (...classes) => customTwMerge(...classes)
